var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"set"},[_c('ul',{staticClass:"set-items"},[_c('li',{staticClass:"set-item set-item-next",on:{"click":_vm.forget_url}},[_vm._v("修改密码")]),_vm._v(" "),_c('li',{staticClass:"set-item",on:{"click":_vm.exit}},[_vm._v("退出登录")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8cb5fc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/me-setting/me-setting.vue
// module id = null
// module chunks = 